import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';
import { trackCtaClick } from '../utils/analytics';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                trackCtaClick('blog', 'inline');
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            trackCtaClick('blog', 'button');
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;